import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';
import { trackCtaClick } from '../utils/analytics';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                trackCtaClick('blog', 'inline');
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            trackCtaClick('blog', 'button');
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;